import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';
import { trackCtaClick } from '../utils/analytics';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                trackCtaClick('blog', 'inline');
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            trackCtaClick('blog', 'button');
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;